import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';
import { trackCtaClick } from '../utils/analytics';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                trackCtaClick('blog', 'inline');
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            trackCtaClick('blog', 'button');
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;